import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';
import { trackCtaClick } from '../utils/analytics';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                trackCtaClick('blog', 'inline');
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            trackCtaClick('blog', 'button');
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;